import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';
import { trackCtaClick } from '../utils/analytics';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                trackCtaClick('blog', 'inline');
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            trackCtaClick('blog', 'button');
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;